import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';
import { trackCtaClick } from '../utils/analytics';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                trackCtaClick('blog', 'inline');
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            trackCtaClick('blog', 'button');
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;